import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';
import { trackCtaClick } from '../utils/analytics';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                trackCtaClick('blog', 'inline');
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            trackCtaClick('blog', 'button');
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;